import React from "react";
import { Button, Modal } from "../../../../components/DesignSystem";
import "./index.scss"

export default function RenderModal({ caseObj, show, onConfirmation, handleChangeStep }) {

  function handleConfirmation(company) {
    onConfirmation(company.id);
    handleChangeStep(1)
  }

  function renderChildren(caseObj) {

    if (caseObj.length === 1 && !show) {
      handleConfirmation(caseObj[0])
    } else {

      return (

        <div style={{ gap: '8px', display: "flex", flexDirection: "column", overflow: "hidden" }}>
          {caseObj.map(item => (
            <Button key={item.id}
              contained
              onClick={() => { handleConfirmation(item); }}
              style={{ justifyContent: "flex-start", width: "auto" }}
            >
              {item.corporate_name}
            </Button>
          ))}
        </div>

      )
    }
  }

  return (
    <Modal
      show={show}
      title='Selecione a empresa devedora.'
      children={renderChildren(caseObj)}
    // renderFooter={null}
    />
  )
}